import React from "react";
import Select from "react-select";

const themeStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "var(--input-bg)",
    borderColor: state.isFocused ? "#3b82f6" : "var(--border-primary)",
    borderRadius: "8px",
    minHeight: "38px",
    boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : "none",
    "&:hover": { borderColor: "var(--text-tertiary)" },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "var(--card-bg)",
    border: "1px solid var(--border-primary)",
    borderRadius: "8px",
    boxShadow: "0 4px 12px var(--card-shadow, rgba(0,0,0,0.15))",
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#3b82f6"
      : state.isFocused
      ? "var(--bg-hover)"
      : "transparent",
    color: state.isSelected ? "#fff" : "var(--text-primary)",
    "&:hover": {
      backgroundColor: state.isSelected ? "#3b82f6" : "var(--bg-hover)",
    },
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "var(--bg-tertiary)",
    borderRadius: "6px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "var(--text-primary)",
    fontSize: "0.82rem",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "var(--text-secondary)",
    borderRadius: "0 6px 6px 0",
    "&:hover": { backgroundColor: "rgba(239,68,68,0.12)", color: "#dc2626" },
  }),
  singleValue: (base) => ({ ...base, color: "var(--text-primary)" }),
  input: (base) => ({ ...base, color: "var(--text-primary)" }),
  placeholder: (base) => ({ ...base, color: "var(--text-tertiary)" }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: "var(--border-primary)" }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "var(--text-tertiary)",
    "&:hover": { color: "var(--text-primary)" },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "var(--text-tertiary)",
    "&:hover": { color: "var(--text-primary)" },
  }),
};

const TagSelector = ({
  options = [],
  value = [],
  onChange,
  placeholder = "Select...",
  label = "",
  isMulti = true,
  id = "",
}) => {
  const selectOptions = options.map((opt) =>
    typeof opt === "string" ? { value: opt, label: opt } : opt
  );
  const selectValue = value.map((v) =>
    typeof v === "string" ? { value: v, label: v } : v
  );

  return (
    <div className="mb-2">
      {label && <label className="form-label">{label}</label>}
      <Select
        id={id}
        isMulti={isMulti}
        options={selectOptions}
        value={selectValue}
        onChange={(selected) => onChange(selected.map((s) => s.value))}
        placeholder={placeholder}
        classNamePrefix="react-select"
        styles={themeStyles}
      />
    </div>
  );
};

export default TagSelector;
